import { apiRequest, buildApiUrl } from '../utils/api';

// Servicio para manejar eventos del calendario
class EventService {
  /**
   * Obtiene todos los eventos
   */
  async getEvents() {
    try {
      const url = buildApiUrl('/events');
      const response = await apiRequest(url, {
        method: 'GET',
      });
      
      return response.response?.content?.events || [];
    } catch (error) {
      console.error('Error al obtener eventos:', error);
      throw error;
    }
  }

  /**
   * Obtiene eventos dentro de un rango de fechas
   */
  async getEventsByDateRange(startDate, endDate) {
    try {
      const events = await this.getEvents();
      
      return events.filter(event => {
        const eventStart = new Date(event.initial_date);
        const eventEnd = new Date(event.final_date);
        
        return (eventStart >= startDate && eventStart <= endDate) ||
               (eventEnd >= startDate && eventEnd <= endDate) ||
               (eventStart <= startDate && eventEnd >= endDate);
      });
    } catch (error) {
      console.error('Error al filtrar eventos por fecha:', error);
      throw error;
    }
  }

  /**
   * Crea un nuevo evento
   */
  async createEvent(eventData) {
    try {
      const url = buildApiUrl('/events');
      const response = await apiRequest(url, {
        method: 'POST',
        body: JSON.stringify({
          name: eventData.name,
          description: eventData.description,
          initialDate: eventData.initialDate,
          finalDate: eventData.finalDate,
          participants: eventData.participants
        }),
      });
      
      return response;
    } catch (error) {
      console.error('Error al crear evento:', error);
      throw error;
    }
  }

  /**
   * Formatea eventos para el calendario
   */
  formatEventsForCalendar(events) {
    return events.map(event => ({
      id: event.id,
      title: event.name,
      description: event.description,
      start: new Date(event.initial_date),
      end: new Date(event.final_date),
      status: event.status,
      participants: event.participants ? event.participants.split(',') : [],
      corporationId: event.corporation_id,
    }));
  }
}

export default new EventService();

